import getBcr from '../utils/getBcr'
import Observable from '../utils/Observable';
import { windowHeight } from '../dimensions';
import round from '../utils/round';
import setTransform from '../utils/setTransform';

const init = element => {
  const factor = parseFloat($(element).data('xr-speed')) - 1;

  const bcr = getBcr(element)

  const offset = Observable.combine([bcr, windowHeight], ([bcr, windowHeight]) => 
    (bcr.top + bcr.height / 2) - (windowHeight / 2)
  )

  const translateY = offset.map(x => x * factor).map(round(2))
  
  const visible = Observable.combine([bcr, translateY, windowHeight], ([bcr, translateY, windowHeight]) => {
    if (bcr.bottom + translateY < 0) return false
    if (bcr.top + translateY > windowHeight) return false
    return true
  })

  const transform = Observable.combine([translateY, visible], ([translateY, visible]) => {
    if (!visible) return false
    return `translate3d(0px,${translateY}px,0px)`
  }).watchDebounced(setTransform(element))
}

jQuery($ => {
  $('[data-xr-speed]').toArray().forEach(init)
})